import { Guest } from '@adminModels';

export interface GuestsState {
  guests: Guest[];
  loading: boolean;
  error: string | null;
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const initialGuestsState: GuestsState = {
  guests: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};
